import type { NavigationItem } from "./navigation";
import { cn } from "@/shared/lib/cn";
import { NavigationItemCard } from "./NavigationItemCard";

interface NavigationSectionProps {
  title: string;
  items: NavigationItem[];
  collapsed: boolean;
  onNavigate?: () => void;
}

export function NavigationSection({
  title,
  items,
  collapsed,
  onNavigate,
}: NavigationSectionProps) {
  return (
    <div className="space-y-3">
      <div
        className={cn(
          "flex items-center gap-2 px-3 text-[0.68rem] font-semibold uppercase tracking-[0.28em] text-white/50 transition-opacity duration-200",
          collapsed && "md:sr-only md:opacity-0"
        )}
      >
        <span className="h-px flex-1 bg-linear-to-r from-white/10 via-white/20 to-imperial-500/50" />
        <span>{title}</span>
      </div>

      <div className="space-y-2">
        {items.map((item) => (
          <NavigationItemCard
            key={item.id}
            item={item}
            collapsed={collapsed}
            onNavigate={onNavigate}
          />
        ))}
      </div>
    </div>
  );
}
